<!-- eslint-disable vue/valid-v-for -->
<template>
  <base-engagement-tool-selection
    :pageHeadingInfo="pageHeadingInfo"
    :carddata="carddata"
    :menudata="menudata"
    @onselectmenu="selectmenu"
    @OnClick1="handle_function_call"
    @OnClick2="handle_function_call"
  >
  </base-engagement-tool-selection>
</template>

<script>
import BaseEngagementToolSelection from "../component/toolselection/base-engagement-tool-selection.vue";
import { mapActions, mapGetters } from "vuex";
import { UserEvent } from "../mixin";
import {
  PageLoad,
  PageLoadAction,
  PageLoadNote,
  LoanSelected,
  InvestmentSelected,
  SuperSelected,
  tabCreatedAction,
  tabSelectedAction,
} from "../helpers/userEvent";
import Loan from "../models/loan";
import Investment from "../models/investment";
import loanModule from "../store/modules/loan";
import InvestmentModule from "../store/modules/investment";
import Superannuation from "../models/superannuation";
import SuperannuationModule from "../store/modules/superannuation";
import store from "../store";

import {
  SET_ENGAGEMENT_COUNT,
  GET_AUTH_INFORMATION,
  GET_ENGAGEMENT_COUNT,
  GET_CLIENT_INFORMATION,
  SET_SELECTED_Liablity_INFORMATION,
  SET_RISK_PROFILE_DATA,
  SET_Liablity_DEFAULT_MODEL,
  SET_SELECTED_INVESTMENT_INFORMATION,
  SET_INVESTMENT_DEFAULT_MODEL,
  SET_SELECTED_SUPERANNUATION_INFORMATION,
  SET_SUPERANNUATION_DEFAULT_MODEL,
  SET_LOADER_VISIBILITY,
} from "../helpers/vuex-constants";
export default {
  components: {
    BaseEngagementToolSelection,
  },
  created() {
    if (this.getAuthInformation.encClientId != undefined) {
      this.getCount(this.getAuthInformation.encClientId);
    }
  },

  props: {},
  mixins: [UserEvent],
  computed: {
    ...mapGetters({
      getAuthInformation: GET_AUTH_INFORMATION,
      getEngagementCount: GET_ENGAGEMENT_COUNT,
      clientInformation: GET_CLIENT_INFORMATION,
    }),

    menudata() {
      return [
        {
          id: 1,
          icon: "home",
          active: this.selectedmenu == 1,
          text: "Pre Retirement",
        },
        // {
        //   id: 2,
        //   icon: "bell",
        //   active: this.selectedmenu == 2,
        //   text: "Superannuation & Retirement",
        // },
        // {
        //   id: 3,
        //   icon: "gear",
        //   active: this.selectedmenu == 3,
        //   text: "Taxation",
        // },
      ];
    },
  },
  watch: {
    "$store.state.root.isClientInformationLoad": function (newVal) {
      if (newVal) {
        this.getCount(this.getAuthInformation.encClientId);
        this.isLoadAuthInformation = false;
        this.saveUserSession(PageLoad, PageLoadAction, PageLoadNote);
      }
    },
  },
  data() {
    return {
      isLoadAuthInformation: true,
      pageHeadingInfo: {
        heading:
          "Select existing or create new instance from the engagement tools",
        subHeading: "",
      },
      carddata: [],
      selectedmenu: 1,
    };
  },

  methods: {
    ...mapActions({
      setLoaderVisibility: SET_LOADER_VISIBILITY,
    }),
    async getCount(id) {
      this.setLoaderVisibility(true);
      await this.setEngagementCount(id);
      this.setLoaderVisibility(false);
      this.addcards();
    },
    ...mapActions("loan", {
      setSelectedLiabilityInfo: SET_SELECTED_Liablity_INFORMATION,
      setLiabilityInformation: SET_Liablity_DEFAULT_MODEL,
    }),
    ...mapActions("investment", {
      setSelectedInvestmentInfo: SET_SELECTED_INVESTMENT_INFORMATION,
      setInvestmentInformation: SET_INVESTMENT_DEFAULT_MODEL,
    }),
    ...mapActions("superannuation", {
      setSelectedSuperannuationInfo: SET_SELECTED_SUPERANNUATION_INFORMATION,
      setSuperannuationInformation: SET_SUPERANNUATION_DEFAULT_MODEL,
    }),
    ...mapActions({
      setEngagementCount: SET_ENGAGEMENT_COUNT,
      setRiskProfileData: SET_RISK_PROFILE_DATA,
    }),

    addcards() {
      this.carddata = [
        {
          title: "Loans",
          firstButtonText: "Create New",
          secondButtonText: "Select Existing",
          caption: this.getEngagementCount.liablitiesCount,
          imagepath: require(`../assets/icons/loans.svg`),
          label: "",
          click1: "createNewLoan",
          click2: "SelectExistingLoan",
          height: "45",
          width: "45",
          showbutton: true,
          disabled: false,
        },
        {
          title: "Investments",
          firstButtonText: "Create New",
          secondButtonText: "Select Existing",
          click1: "createNewInvestment",
          caption: this.getEngagementCount.investmentsCount,
          imagepath: require(`../assets/icons/investments.svg`),
          label: "",
          height: "45",
          width: "45",
          showbutton: true,
          disabled: false,
          click2: "SelectExistingInvestment",
        },
        {
          title: "Superannuation & Retirement",
          firstButtonText: "Create New",
          click1: "createNewSuperannuation",
          secondButtonText: "Select Existing",
          caption: this.getEngagementCount.superCount,
          imagepath: require(`../assets/icons/super.svg`),
          label: "",
          height: "45",
          width: "45",
          showbutton: true,
          disabled: false,
          click2: "SelectExistingSuperannuation",
        },
        // {
        //   title: "Property",
        //   firstButtonText: "Create New",
        //   secondButtonText: "Select Existing",
        //   caption: "",
        //   imagepath: require(`../assets/icons/property.svg`),
        //   label: "Coming Soon",
        //   height: "45",
        //   width: "45",
        //   disabled: true,
        // },
        // {
        //   title: "Geared Investments",
        //   firstButtonText: "Create New",
        //   secondButtonText: "Select Existing",
        //   caption: "",
        //   imagepath: require(`../assets/icons/generalinvestments.svg`),
        //   label: "Coming Soon",
        //   height: "45",
        //   width: "45",
        //   disabled: true,
        // },
      ];
    },
    selectmenu(data) {
      this.selectedmenu = data.id;
      if (this.selectedmenu == 1) {
        this.addcards();
      } else {
        this.carddata = [];
      }
    },
    SelectExistingLoan() {
      this.unRegisterAllModule();
      this.registerLoanModule();
      this.$router.push("/loan-instance-selection");
      this.saveUserSession(LoanSelected, tabSelectedAction, "");
    },
    SelectExistingInvestment() {
      this.unRegisterAllModule();
      this.registerInvestmentModule();

      this.$router.push("/investment-instance-selection");
      this.saveUserSession(InvestmentSelected, tabSelectedAction, "");
    },

    async SelectExistingSuperannuation() {
      this.unRegisterAllModule();
      this.registerSuperannuationModule();
      await this.getRiskProfileData();
      this.$router.push("/superannuation-instance-selection");
      this.saveUserSession(SuperSelected, tabSelectedAction, "");
    },
    openBasicLoanFom() {
      let parentClientIndex = this.clientInformation.findIndex(
        (sr) => sr.entityType == 1
      );
      if (parentClientIndex >= 0) {
        let loanModel = Loan.getEmptyLoanModel(
          this.clientInformation[parentClientIndex]
        );
        let loanModels = [];
        loanModels.push(loanModel);
        this.setLiabilityInformation(loanModels);
        this.setSelectedLiabilityInfo(loanModel);
        this.saveUserSession(LoanSelected, tabCreatedAction, "");
        this.$router.push({ name: "loan-engagement-tool" });
      }
    },
    createNewLoan() {
      this.unRegisterAllModule();
      this.registerLoanModule();
      this.openBasicLoanFom();
    },
    async createNewInvestment() {
      this.setLoaderVisibility(true);
      await this.setRiskProfileData(this.getAuthInformation);
      this.setLoaderVisibility(false);
      this.unRegisterAllModule();
      this.registerInvestmentModule();
      this.openBasicInvestmentForm();
    },

    async createNewSuper() {
      this.setLoaderVisibility(true);
      await this.setRiskProfileData(this.getAuthInformation);
      this.setLoaderVisibility(false);
      this.unRegisterAllModule();
      this.registerSuperModule();
      this.openBasicSuperEngagementTool();
    },
    openBasicSuperEngagementTool() {
      this.saveUserSession(SuperSelected, tabCreatedAction, "");
      this.$router.push({ name: "super-engagement-tool" });
    },
    openBasicInvestmentForm() {
      let parentClientIndex = this.clientInformation.findIndex(
        (sr) => sr.entityType == 1
      );
      if (parentClientIndex >= 0) {
        let investmentModel = Investment.getEmptyInvestmentModel(
          this.clientInformation[parentClientIndex]
        );
        let investmentModels = [];
        investmentModels.push(Object.assign({}, investmentModel));
        this.setInvestmentInformation(investmentModels);
        this.setSelectedInvestmentInfo(investmentModel);
        this.saveUserSession(InvestmentSelected, tabCreatedAction, "");
        this.$router.push({ name: "investment-engagement-tool" });
      }
    },
    async createNewSuperannuation() {
      this.unRegisterAllModule();
      this.registerSuperannuationModule();
      this.openBasicSuperannuationForm();
    },
    async getRiskProfileData() {
      this.setLoaderVisibility(true);
      await this.setRiskProfileData(this.getAuthInformation);
      this.setLoaderVisibility(false);
    },
    async openBasicSuperannuationForm() {
      await this.getRiskProfileData();

      let parentClientIndex = this.clientInformation.findIndex(
        (sr) => sr.entityType == 1
      );
      if (parentClientIndex >= 0) {
        let superannuationModel = Superannuation.getEmptySuperannuationModel(
          this.clientInformation[parentClientIndex]
        );
        let superannuationModels = [];
        superannuationModels.push(Object.assign({}, superannuationModel));
        this.setSuperannuationInformation(superannuationModels);
        this.setSelectedSuperannuationInfo(superannuationModel);
        this.saveUserSession(SuperSelected, tabCreatedAction, "");
        this.$router.push({ name: "superannuation-engagement-tool" });
      }
    },

    unRegisterAllModule() {
      if (store.hasModule("loan")) {
        store.unregisterModule("loan");
      }
      if (store.hasModule("investment")) {
        store.unregisterModule("investment");
      }

      if (store.hasModule("superannuation")) {
        store.unregisterModule("superannuation");
      }
    },
    registerLoanModule() {
      store.registerModule("loan", loanModule);
    },
    registerInvestmentModule() {
      store.registerModule("investment", InvestmentModule);
    },

    registerSuperannuationModule() {
      store.registerModule("superannuation", SuperannuationModule);
    },
    handle_function_call(function_name) {
      this[function_name]();
    },
  },
};
</script>

<style></style>
